import React from "react";

import {
    formatEmployeeLabel,
} from "../utils/employee.utils";

import "./EmployeeCommon.css";


const EmployeeStatusBadge = ({
    status = "",
}) => {

    const normalizedStatus =
        String(
            status ||
            ""
        )
            .trim()
            .toUpperCase();


    const statusClass =
        normalizedStatus
            .toLowerCase()
            .replace(
                /_/g,
                "-"
            );


    return (

        <span
            className={
                `employee-common-status employee-common-status--${statusClass}`
            }
        >

            {
                formatEmployeeLabel(
                    normalizedStatus
                ) ||
                "-"
            }

        </span>

    );

};


export default EmployeeStatusBadge;